import React, { useState } from 'react';
import { ArrowLeft, Building2, MessageSquareText, Smartphone } from 'lucide-react';
import ConversationList from './ConversationList';
import ConversationThread from './ConversationThread';

const PROVIDER_FILTERS = [
  ['all', 'Activas'],
  ['unread', 'Sin leer'],
  ['delivery_issue', 'Incidencias'],
  ['store', 'Tiendas'],
];

export default function ProviderCommunicationInbox({ userId, setActiveComponent }) {
  const [selected, setSelected] = useState(null);

  return (
    <div className="flex h-screen w-screen flex-col overflow-hidden bg-slate-100">
      <div className="flex items-center gap-3 border-b border-slate-200 bg-white px-3 py-3 sm:px-4">
        <button
          onClick={() => setActiveComponent?.('OptionsAdmin')}
          className="inline-flex flex-shrink-0 items-center gap-2 rounded-lg bg-slate-100 px-3 py-2 text-sm font-bold text-slate-700 hover:bg-slate-200"
        >
          <ArrowLeft className="h-4 w-4" />
          Menú
        </button>
        <div className="min-w-0">
          <h1 className="truncate text-base font-extrabold text-slate-950 font-montserrat sm:text-lg">Chat proveedor</h1>
          <p className="line-clamp-2 text-xs text-slate-500">
            Comunicación interna de entregas para tus tiendas y operaciones activas.
          </p>
        </div>
      </div>

      <div className="flex min-h-0 flex-1 overflow-hidden">
        <div className={`${selected ? 'hidden sm:block' : 'block'} w-full sm:w-[430px]`}>
          <ConversationList
            scope="provider"
            userId={userId}
            selectedConversationId={selected?.id}
            onSelect={setSelected}
            title="Entregas del proveedor"
            subtitle="Hilos internos de tiendas + Fast Max"
            filterOptions={PROVIDER_FILTERS}
            limit={25}
            searchPlaceholder="Buscar tienda, entrega, cliente, dirección o mensaje"
          />
        </div>
        <div className={`${selected ? 'flex' : 'hidden sm:flex'} min-w-0 flex-1 flex-col gap-2 p-2 sm:gap-3 sm:p-4`}>
          {selected && (
            <button
              type="button"
              onClick={() => setSelected(null)}
              className="inline-flex items-center gap-2 rounded-lg bg-white px-3 py-2 text-sm font-bold text-slate-700 shadow-sm ring-1 ring-slate-200 hover:bg-slate-50 sm:hidden"
            >
              <ArrowLeft className="h-4 w-4" />
              Conversaciones
            </button>
          )}
          <div className="hidden gap-3 md:grid md:grid-cols-3">
            <div className="rounded-xl border border-slate-200 bg-white p-3 text-xs text-slate-600 shadow-sm">
              <div className="mb-1 flex items-center gap-2 font-bold text-slate-900">
                <Building2 className="h-4 w-4 text-[#B1336E]" />
                Alcance proveedor
              </div>
              Ves conversaciones de entregas bajo tu proveedor o tiendas asociadas.
            </div>
            <div className="rounded-xl border border-slate-200 bg-white p-3 text-xs text-slate-600 shadow-sm">
              <div className="mb-1 flex items-center gap-2 font-bold text-slate-900">
                <MessageSquareText className="h-4 w-4 text-sky-600" />
                Operación interna
              </div>
              Puedes coordinar con Fast Max, tienda y motorizado en el hilo de la entrega.
            </div>
            <div className="rounded-xl border border-slate-200 bg-white p-3 text-xs text-slate-600 shadow-sm">
              <div className="mb-1 flex items-center gap-2 font-bold text-slate-900">
                <Smartphone className="h-4 w-4 text-emerald-600" />
                WhatsApp como canal
              </div>
              También puedes escribir al WhatsApp del cliente final cuando la ventana de 24h esté abierta.
            </div>
          </div>

          <ConversationThread
            conversationId={selected?.id}
            currentUserId={userId}
            currentUserType="provider"
            className="min-h-0 flex-1"
            allowNotes={false}
            inputPlaceholder="Escribe al hilo interno de esta entrega..."
            inputHelperText="Mensaje interno: Fast Max, tienda y participantes de la entrega podrán verlo. Cambia a WhatsApp cliente para escribir al cliente final."
            enableFinalCustomerWhatsApp
            enableDeliverySlotSelection
          />
        </div>
      </div>
    </div>
  );
}
